var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading" }, [
      _c("div", { staticClass: "loading__holder" }, [
        _c("i", { staticClass: "uk-icon-spinner uk-icon-spin" }),
        _vm._v(" "),
        _c("span", [_vm._v("Загрузка")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }